document.addEventListener('DOMContentLoaded', function () {
	initRelatedProductsSliders();
});

/**
 * Initialize all related products sliders on the page
 */
function initRelatedProductsSliders() {
	const sliders = document.querySelectorAll('.related-products-slider');

	sliders.forEach(slider => {
		// Проверяем тип отображения (используем только для слайдеров)
		const displayType = slider.dataset.displayType || 'slider';

		// Если это не слайдер или слайдер уже инициализирован, пропускаем
		if (displayType !== 'slider' || slider.dataset.initialized === 'true') {
			return;
		}

		const loop = slider.dataset.loop === 'true';
		const autoplay = slider.dataset.autoplay === 'true';
		const autoplaySpeed = parseInt(slider.dataset.autoplaySpeed) || 3000;
		const showButtons = slider.dataset.showButtons === 'true';

		const container = slider.querySelector('.swiper-container');

		if (!container) return;

		// Autoplay settings
		const autoplayConfig = autoplay ? {
			delay: autoplaySpeed,
			disableOnInteraction: false
		} : false;

		// Navigation settings
		const navigationConfig = showButtons ? {
			nextEl: slider.querySelector('.swiper-button-next'),
			prevEl: slider.querySelector('.swiper-button-prev'),
		} : false;

		// Initialize slider
		new Swiper(container, {
			slidesPerView: 'auto',
			loop: loop,
			autoplay: autoplayConfig,
			navigation: navigationConfig
		});

		// Отмечаем слайдер как инициализированный
		slider.dataset.initialized = 'true';
	});
}

